import styled from "styled-components";

export const Card = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 18px 16px;
  overflow: hidden;
`;

export const FieldsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FieldShell = styled.div`
  background: #f6f6f6;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  height: 48px;
  padding: 4px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.3);
  margin-bottom: 4px;
  line-height: 16px;
`;

export const Asterisk = styled.span`
  color: #ec2127;
  font-weight: 700;
  margin-left: 0;
`;

export const MobileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 19px;
`;

export const CountryTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  padding: 0 6px 0 0;
  cursor: pointer;
  font-size: 16px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
  line-height: 24px;

  &:disabled {
    cursor: default;
    opacity: 0.85;
  }
`;

export const TextInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 900;
  font-family: inherit;
  color: rgba(0, 0, 0, 0.3);
  min-width: 0;
  outline: none;
  line-height: 24px;

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
    font-weight: 900;
  }

  &:read-only {
    cursor: default;
  }

  &:disabled {
    opacity: 1;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.3);
  }
`;

export const EmailFieldInput = styled(TextInput)`
  flex: none;
  width: 100%;
  display: block;
`;

export const FieldError = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #ec2127;
  margin-top: 4px;
  padding-left: 2px;
`;
